
    let dragSrcEl;
    const items = document.getElementsByClassName('returm-box-for-image');

    document.addEventListener('dragstart', function(e){

    if (e.target.classList.contains("returm-box-for-image")) {
        e.target.style.opacity = '0.4';

        dragSrcEl = e.target;

        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', e.target.innerHTML);
    }
    });

    document.addEventListener('dragenter', function(e){
    if (e.target.classList.contains("returm-box-for-image")) {
        e.target.classList.add('over');
    }
    });


    document.addEventListener('dragover', function(e){
    if (e.target.classList.contains("returm-box-for-image")) {

        if (e.preventDefault) {
            e.preventDefault();
        }

        e.dataTransfer.dropEffect = 'move';

        
    }
    });

    document.addEventListener('dragleave', function(e){
    if (e.target.classList.contains("returm-box-for-image")) {

        e.target.classList.remove('over'); 
    }
    });

    document.addEventListener('drop', function(e){
    if (e.target.classList.contains("returm-box-for-image")) {
        if (e.stopPropagation) {
        e.stopPropagation(); // stops the browser from redirecting.
        }
        
        if (dragSrcEl !== e.target) {
        dragSrcEl.innerHTML = e.target.innerHTML;
        
        e.target.innerHTML = e.dataTransfer.getData('text/html');
        }
    }
    });

    document.addEventListener('dragend', function(e){

    if (e.target.classList.contains("returm-box-for-image")) {
        e.target.style.opacity = '1';  
        Array.prototype.forEach.call(items, function(item) {
        item.classList.remove('over');
        });

    }
    });
